export const faqRecords = [
  {
    id: "what-is-juristai",
    sortOrder: 10,
    published: true,
    showOnLanding: true,
    question: "What exactly is Vienna?",
    answerHtml:
      "<p>Nougat makes Vienna, a legal operations agent you hire to manage your firm's tools. You email Vienna or message it in Slack or Teams, and it works across your documents, deadlines, research, drafts, citations, tasks, and billing, keeping every matter on one record.</p><p>Start with the practice area you need, such as civil litigation, criminal defense, or startup & VC work, and expand from there.</p>",
  },
  {
    id: "what-does-it-automate",
    sortOrder: 20,
    published: true,
    showOnLanding: true,
    question: "What work does Vienna take off our plate?",
    answerHtml:
      "<p>Vienna handles the connective work that is easy to miss and expensive to repeat: filing incoming material, surfacing deadlines, creating follow-up tasks, drafting, checking citations, scheduling, and preparing matter updates.</p><p>Your team keeps the judgment calls. Vienna keeps the work moving between them.</p>",
  },
  {
    id: "who-is-it-for",
    sortOrder: 30,
    published: true,
    showOnLanding: true,
    question: "Is Vienna for a solo attorney, a firm, or an in-house team?",
    answerHtml:
      "<p>All three. Solo practitioners can use it to create structure without adding more administrative overhead. Firms can standardize how matters are organized and reviewed. In-house teams can keep legal work, owners, and next steps visible without rebuilding context in every meeting.</p>",
  },
  {
    id: "civil-criminal",
    sortOrder: 40,
    published: true,
    showOnLanding: true,
    question: "Which legal workflows can we use today?",
    answerHtml:
      "<p>Vienna supports civil litigation and demands, criminal defense, startup & VC work, legal research, citation verification, matter and docket updates, document organization, and deadline awareness. The workflows are practice-area and jurisdiction specific, so the experience starts with relevant context instead of a blank generic chat box.</p>",
  },
  {
    id: "citation-checker-reliability",
    sortOrder: 50,
    published: true,
    showOnLanding: true,
    question: "Can we trust the output on high-stakes work?",
    answerHtml:
      "<p>Vienna is designed to make review more disciplined, not to remove it. Citation checks flag risky citations, unsupported references, and formatting issues; matter-aware workflows keep drafts tied to source material; and audit-ready records make it easier to see what happened.</p><p>Nothing is filed or sent to a client without your approval, and your team stays responsible for reviewing it first.</p>",
  },
  {
    id: "email-workflows",
    sortOrder: 60,
    published: true,
    showOnLanding: true,
    question: "Do we have to make everyone learn another dashboard?",
    answerHtml:
      "<p>No. Most people just email Vienna or message it in Slack or Teams, and review its updates, drafts, and flags where they already work. The workspace is there when someone wants the full matter view, but nobody has to become a power user on day one.</p>",
  },
  {
    id: "pro-se",
    sortOrder: 70,
    published: true,
    showOnLanding: true,
    question: "How do we get started?",
    answerHtml:
      "<p>Sign up, book your onboarding call, and connect your email, calendar, and file storage. Then forward Vienna a matter, or open one, and it starts organizing the record, flagging next steps, and keeping updates tied to the case. A guided demo is the fastest way to see where Vienna fits your team.</p>",
  },
  {
    id: "not-a-lawyer",
    sortOrder: 80,
    published: true,
    showOnLanding: true,
    question: "How is confidential legal work protected?",
    answerHtml:
      "<p>Vienna encrypts data in transit and at rest, does not share your data or use it for external model training, and maintains enterprise-oriented controls for confidential filings, drafts, and correspondence. Visit the <a href=\"https://app.vanta.com/juristai.org/trust/0clwm7e9sja31xt60a2lum\">trust center</a> for the current security and compliance details.</p>",
  },
  {
    id: "getting-started",
    sortOrder: 90,
    published: true,
    showOnLanding: true,
    question: "Does Vienna replace our lawyers or our professional judgment?",
    answerHtml:
      "<p>No. Vienna is software, not a law firm. It does not provide legal advice, legal representation, or create an attorney-client relationship. It gives legal professionals better context, faster quality checks, and less repetitive work so they can spend more time on strategy and judgment.</p>",
  },
];
